import { useCallback } from 'react';

export type InputChangeEvent<T = string> = {
  currentTarget: {
    value: T;
  };
};

export type SimpleChangeEvent<T = string> = T;

export type ChangeEvent<T = string> = InputChangeEvent<T> | SimpleChangeEvent<T>;

export const useChangeEvent = <T extends unknown = string>(callback?: Setter<T>) =>
  useCallback(
    (event: ChangeEvent<T>) => {
      callback?.(
        typeof event === 'object' && event !== null && 'currentTarget' in event
          ? event.currentTarget.value
          : event,
      );
    },
    [callback],
  );
